module.exports = __webpack_public_path__ + "img/Big_Arts_Yokel@3x.8b0a5158.png";